<!-- <template>
  <div class="container">
    <h1 v-if="error.statusCode === 404">Page not found</h1>
    <h1 v-else>An error occurred</h1>
    <NuxtLink to="/">Home page</NuxtLink>
  </div>
</template>

<script>
export default {
  props: ['error'],
  layout: 'blog' // you can set a custom layout for the error page
}
</script> -->

<template>
  <div class="four_main">
    <img height="70px" width="50%" :src="cdnUrl + '/404.svg'" alt="" />
    <div class="hint_text">
      <p>Uh oh. That page doesn’t exist.</p>
      <p>Head to our <a href="/">Homepage</a></p>
    </div>
    <CookieBanner />
  </div>
</template>

<script setup>
import { useHead } from "#imports";
import CookieBanner from "@/components/common/CookieBanner";
import defaultCssUrl from "~/assets/styles/index.scss?url";
const cdnUrl = useRuntimeConfig().public.cdnUrl;
useHead({
  link: [
    {
      rel: "stylesheet",
      href: defaultCssUrl,
      crossorigin: "anonymous",
      key: "layout-style",
    },
  ],
});

// 引入全局样式，确保404页面样式一致
useHead({
  title: "SharkFoto - Page Not Found",
  meta: [
    {
      hid: "description",
      name: "description",
      content: "SharkFoto - Page Not Found",
    },
    {
      hid: "og:site_name",
      property: "og:site_name",
      content: "SharkFoto",
    },
    {
      hid: "og:type",
      property: "og:type",
      content: "website",
    },
    {
      hid: "og:locale",
      property: "og:locale",
      content: "en_US",
    },
    {
      hid: "og:image",
      property: "og:image",
      content: `${cdnUrl}/sharkfoto_og.png`,
    },
    {
      hid: "og:url",
      property: "og:url",
      content: "https://sharkfoto.com/404.html",
    },
    {
      hid: "og:title",
      property: "og:title",
      content: "SharkFoto - Page Not Found",
    },
    {
      hid: "og:description",
      property: "og:description",
      content: "SharkFoto - Page Not Found",
    },
    {
      hid: "twitter:card",
      name: "twitter:card",
      content: "summary_large_image",
    },
    {
      hid: "twitter:url",
      name: "twitter:url",
      content: "https://sharkfoto.com/404.html",
    },
    {
      hid: "twitter:title",
      name: "twitter:title",
      content: "SharkFoto - Page Not Found",
    },
    {
      hid: "twitter:image",
      name: "twitter:image",
      content: `${cdnUrl}/sharkfoto_og.png`,
    },
    {
      hid: "twitter:site",
      name: "twitter:site",
      content: "@SharkFoto_US",
    },
    {
      hid: "twitter:description",
      name: "twitter:description",
      content: "SharkFoto - Page Not Found",
    },
  ],
});
</script>

<style scoped lang="scss">
/* 404页面 */
.four_main {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  // font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Ubuntu, Helvetica Neue, Helvetica, Arial, PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Source Han Sans CN, sans-serif;
}

.four_main img {
  height: 100%;
  min-width: 215px;
  max-width: 750px;
  clip: rect(0px, 60px, 200px, 0px);
}

.four_main .hint_text {
  display: flex;
  flex-direction: column;
  align-items: left;
}

.four_main .hint_text p:nth-child(1) {
  font-size: 30px;
  font-weight: 700;
}

.four_main .hint_text p:nth-child(2) {
  /* font: 18px; */
  font-size: 22px;
  font-weight: bold;
  a {
    color: #5171ff;
  }
}

.four_main a {
  text-decoration: none;
}

@media (max-width: 960px) {
  .four_main {
    padding: 50px;
  }

  .four_main .hint_text p:nth-child(1) {
    font-size: 1.5em;
    font-weight: 700;
  }

  .four_main .hint_text p:nth-child(2) {
    font-size: 1.3em;
    font-weight: bold;
  }
}
</style>
